import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Watchlist store — persists favorited trading symbols to localStorage.
 * Used across the app to let users star/unstar tokens and view them
 * in a dedicated watchlist panel.
 */

interface WatchlistState {
  /** Set of favorited symbol strings (e.g. "BTCUSDT", "ETHUSDT") */
  symbols: string[]

  /** Add a symbol to the watchlist */
  addSymbol: (symbol: string) => void

  /** Remove a symbol from the watchlist */
  removeSymbol: (symbol: string) => void

  /** Toggle a symbol in/out of the watchlist */
  toggleSymbol: (symbol: string) => void

  /** Check if a symbol is in the watchlist */
  isWatchlisted: (symbol: string) => boolean
}

export const useWatchlistStore = create<WatchlistState>()(
  persist(
    (set, get) => ({
      symbols: [],

      addSymbol: (symbol: string) => {
        const current = get().symbols
        if (!current.includes(symbol)) {
          set({ symbols: [...current, symbol] })
        }
      },

      removeSymbol: (symbol: string) => {
        set({ symbols: get().symbols.filter((s) => s !== symbol) })
      },

      toggleSymbol: (symbol: string) => {
        const current = get().symbols
        if (current.includes(symbol)) {
          set({ symbols: current.filter((s) => s !== symbol) })
        } else {
          set({ symbols: [...current, symbol] })
        }
      },

      isWatchlisted: (symbol: string) => {
        return get().symbols.includes(symbol)
      },
    }),
    {
      name: 'algoglide-watchlist',
    }
  )
)
